import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import {
    PaymentMethodsFacade,
    PurchaseFacade,
    ShoppingCartFacade,
    ShoppingCartState,
    SwishFacade
} from '@ridango/components';
import { clearCartState, loadCartState } from '@ridango/components/lib/localStorage';
import { AuthService, LogService, PaymentMethod, PaymentType } from '@ridango/core';
import Env from '@ridango/core/env';
import { EmptyCartOptions } from '@ridango/core/lib/enums/features.enum';
import { CartSummaryComponent } from '@ridango/widgets';
import { CartSwishComponent } from '@ridango/widgets';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: './shopping-cart-page.component.html',
    styleUrls: ['./shopping-cart-page.component.scss']
})
export class ShoppingCartPageComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();

    emptyCartOptions = EmptyCartOptions;
    paymentTypeEnum = PaymentType;

    steps$: Observable<any[]> = this.purchaseFacade.purchaseSteps$;
    activeStep$: Observable<number> = this.purchaseFacade.activePurchaseStep$;
    cart$: Observable<ShoppingCartState> = this.cartFacade.cart$;
    selectedPaymentMethod$: Observable<PaymentMethod> = this.paymentFacade.selectedPaymentMethod$;
    swishTransaction$: Observable<any> = this.swishFacade.transaction$;

    locale;
    cartId;

    @ViewChild(CartSwishComponent) swishComponentEl;
    @ViewChild(CartSummaryComponent) cartSummaryComponent: CartSummaryComponent;

    constructor(
        private cartFacade: ShoppingCartFacade,
        private purchaseFacade: PurchaseFacade,
        private paymentFacade: PaymentMethodsFacade,
        public ridangoAuth: AuthService,
        private router: Router,
        private translate: TranslateService,
        private swishFacade: SwishFacade,
        private ls: LogService,
        @Inject('ENV') public environment: Env,
        @Inject(DOCUMENT) private document: Document
    ) {}

    ngOnInit() {
        this.scrollToTop();

        // should be correct
        this.purchaseFacade.setActiveWalletPurchaseStep(2);
        this.locale = this.translate.currentLang;

        this.swishTransaction$.pipe(takeUntil(this.componentDestroyed$)).subscribe((s) => {
            if (s && s.status) {
                this.router.navigate([this.translate.currentLang, 'swish']);
            }
        });

        this.cart$.pipe(takeUntil(this.componentDestroyed$)).subscribe((c) => {
            this.cartId = c.shopping_cart_id;
        });

        const loadCart = new Promise((resolve, reject) => {
            const t = loadCartState();
            if (t) {
                const c = Object.assign({}, JSON.parse(JSON.stringify(t)));
                if (c) {
                    resolve(c);
                } else {
                    reject();
                }
            } else {
                reject();
            }
        });

        loadCart
            .then((c) => {
                if (!this.cartId) {
                    this.cartFacade.hydrateState(Object.assign({}, JSON.parse(JSON.stringify(c))));
                }
                clearCartState();
            })
            .catch((e) => {
                this.ls.log(this, 'no cart to load', e);
            });
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    swishInvalid() {
        this.swishComponentEl.fieldEl.nativeElement.focus();
    }

    canDeactivate() {
        if (this.cartSummaryComponent) {
            return this.cartSummaryComponent.canDeactivate();
        }
        return true;
    }

    private scrollToTop(): void {
        const scrollableElement = document.querySelector('main')
            ? document.querySelector('main')
            : document.querySelector('ion-content');

        if (scrollableElement) {
            scrollableElement.scrollTo(0, 0);
        }
    }
}
